import React from 'react';
import BouncyLoader from '@/presentation/components/loader/bouncy-loader';
const OverlayBouncyLoader = () => {
    return (React.createElement("div", { className: 'page-loader-container' },
        React.createElement("div", { className: "overlay" },
            React.createElement(BouncyLoader, null))));
};
export default OverlayBouncyLoader;
